import { useMemo } from "react";

type ArgType = {
	value: any
	items: any[]
	getItemId(item: any): string | number
}

export const useSelectedItems = ({ value, items, getItemId }: ArgType) => {
	return useMemo(
		() => {
			const newSelectedItems: any[] = [];
			const newRemainingItems: any[] = [];

			for (const item of items) {
				const itemId = getItemId(item);
				if (value?.includes(itemId)) {
					newSelectedItems.push(item);
				} else {
					newRemainingItems.push(item);
				}
			}

			return {
				selectedItems: newSelectedItems,
				remainingItems: newRemainingItems
			}
		},
		[value, items, getItemId]
	)
}
